import { render } from "./ExportModal.vue?vue&type=template&id=5ca6822c&scoped=true"
import script from "./ExportModal.vue?vue&type=script&lang=js"
export * from "./ExportModal.vue?vue&type=script&lang=js"

import "./ExportModal.vue?vue&type=style&index=0&id=5ca6822c&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca6822c"]])

export default __exports__